// Server-rendered HTML (a letter, a prepared document) shown in a new tab to print or copy.
// The tab is opened on the click itself so popup blockers allow it, then filled when the HTML arrives.
export function openBlankTab() {
  return window.open('', '_blank');
}

export function showPrintable(tab: Window | null, html: string) {
  const url = URL.createObjectURL(new Blob([html], { type: 'text/html' }));
  if (tab) tab.location.href = url;
  else window.open(url, '_blank');
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export function errorMessage(err: unknown, fallback: string) {
  const data = (err as { response?: { data?: { error?: string } } })?.response?.data;
  return data?.error ?? (err instanceof Error ? err.message : fallback);
}
